import { InvoiceStatus } from "@jugl-web/rest-api/invoices/models/common-types";
import { InvoicesStatusBadge } from "../../InvoicesStatusBadge/InvoicesStatusBadge";

interface ComponentProps {
  details: Array<{
    id: "invoice-number" | "type" | "payment-status";
    value: string;
  }>;
}

export const ComposedCell: React.FC<ComponentProps> = ({ details }) => {
  const renderDetail = (detail: { id: string; value: string }) => {
    switch (detail.id) {
      case "invoice-number":
        return (
          <div className="pt-4 pl-4 font-secondary text-sm font-medium text-dark-800">
            {detail.value}
          </div>
        );
      case "type":
        return (
          <div className="pl-4 font-secondary text-sm font-normal text-dark-600">
            {detail.value}
          </div>
        );
      case "payment-status":
        return <InvoicesStatusBadge status={detail.value as InvoiceStatus} />;
      default:
        return <div>{detail.value}</div>;
    }
  };

  return (
    <ul className="my-0 space-y-1 pl-0">
      {details.map((detail) => (
        <li key={`${detail.id}-${detail.value}`} className="list-none">
          {renderDetail(detail)}
        </li>
      ))}
    </ul>
  );
};
